import { Icon } from "@/assets/icons";
import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../Button";
import brokenImg from "@/assets/fatal_error4.svg"

const Screen500: React.FC = () => {
  return (
    <div className="flex flex-col items-center gap-2 lg:h-[100vh] justify-center">
      <img src={brokenImg} alt="500page" />
      <div className="text-cyan text-3xl-plus font-bold">
        500 Service Unavailable
      </div>
      <div className="text-cyan text-lg leading-160% font-bold">
        アクセスしようとしたページは表示できませんでした
      </div>
      <div className="text-light_secondary leading-160% font-noto-sans">
        <div>ただいまアクセスが集中している可能性があります。</div>
        <div>時間をおいて再度アクセスをお試しください。</div>
      </div>
      <Link to="/">
        <Button
          type="button"
          variant="solid"
          color="primary"
          iconLeft={<Icon name="home" />}
          className="!h-12"
        >
          トップページへ
        </Button>
      </Link>
    </div>
  );
};

export { Screen500 };
